"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _exportButton = _interopRequireDefault(require("../../../../core/export-button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getInitialState() {
  return {
    selectingExport: false,
    generatingExport: false,
    selectingCutAndPaste: false,
    selectedDayID: null
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "This will export and download a file that can be imported into Simply Slalom."), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Download the File (it will go to your download folder)"), /*#__PURE__*/_react.default.createElement("li", null, "Copy the File to the computer being used to run Simply Slalom"), /*#__PURE__*/_react.default.createElement("li", null, "Open Simply Slalom"), /*#__PURE__*/_react.default.createElement("li", null, "Ctrl + Shift + R"), /*#__PURE__*/_react.default.createElement("li", null, "Click the button to upload the data and follow the instructions")), /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "info"
}, /*#__PURE__*/_react.default.createElement("p", null, "If you are expecting walk-ups and running a two-day competition, then it is recommended that you enter the walk-ups onto Simply Slalom first; save a copy of SS with your walk-ups ready for Sunday; then use the import button to upload and merge your online entries.")));
class SimplySalomExport extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", getInitialState());
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(getInitialState());
    });
    _defineProperty(this, "_onBegin", () => {
      this.setState({
        selectingExport: true
      });
    });
    // this automatically closes the modal, but delays to allow some time for downloading
    // ideally want to know when generating is finished, but this is a compromise.
    _defineProperty(this, "_onGenerateExport", () => {
      this.setState({
        generatingExport: true
      });
      setTimeout(() => {
        this._onCloseCancel();
      }, 2000);
    });
  }
  render() {
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_exportButton.default, {
      name: "simply-slalom-export",
      args: {
        competitionSlug: this.props.competitionSlug,
        yearID: this.props.yearID,
        delimiter: '|'
      },
      type: "primary",
      onClick: this._onGenerateExport
    }, "Download Export"));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onBegin,
      type: "primary",
      block: true
    }, "Export for Simply Slalom"), !this.state.selectingExport ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Export for Simply Slalom",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, _ref));
  }

  //*******************************************************************************
  // partialQueries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(SimplySalomExport, "partialQueries", {
  CompetitionDay: {
    id: true,
    dayDate: true
  }
});
var _default = exports.default = SimplySalomExport;